import { ThunkDispatch, UnknownAction } from '@reduxjs/toolkit';

import { STODocumentStatusEnum } from 'commons/enums';
import { STODocument } from 'commons/types';
import {
  bulkSetSTODocumentToStatusArrived,
  retryUpdateFailedSTODocuments,
  setSTODocumentToStatusArrived,
} from 'redux-stores/actions';

import {
  ISTOBulkDialogData,
  ISTODialogData,
} from '../types/sto-dialog-state.interface';

export const RowMenuItemConfig: Record<string, ISTODialogData | null> = {
  set_arrived: {
    title: 'Set Arrived',
    content: (stoNumber: string): string => {
      return `Are you sure to move status ${stoNumber} to arrived?`;
    },
    onConfirm: (
      dispatch: ThunkDispatch<unknown, unknown, UnknownAction>,
      stoNumber: string,
      location?: number,
    ): void => {
      dispatch(setSTODocumentToStatusArrived({ stoNumber, location }));
    },
  },
  retry_ns_fulfill: {
    title: 'Retry Fulfillment',
    content: (stoNumber: string): string => {
      return `Are you sure to retry ${stoNumber}?`;
    },
    onConfirm: (
      dispatch: ThunkDispatch<unknown, unknown, UnknownAction>,
      stoNumber: string,
      location?: number,
    ): void => {
      dispatch(
        retryUpdateFailedSTODocuments({ stoNumbers: [stoNumber], location }),
      );
    },
  },
};

export const RowMenuItemBulkConfig: ISTOBulkDialogData[] = [
  {
    title: 'Set Arrived',
    disabled: (documents: STODocument[]) => {
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < documents.length; i++) {
        if (documents[i].status !== STODocumentStatusEnum.SHIPPED) return true;
      }
      return false;
    },
    content: (stoNumbers: string[]): string => {
      return `Are you sure to move status ${stoNumbers.join(', ')} to arrived?`;
    },
    onConfirm: (
      dispatch: ThunkDispatch<unknown, unknown, UnknownAction>,
      stoNumbers: string[],
      location?: number,
    ): void => {
      dispatch(bulkSetSTODocumentToStatusArrived({ stoNumbers, location }));
    },
  },
  {
    title: 'Retry Fulfillment',
    content: (stoNumbers: string[]): string => {
      return `Are you sure to retry ${stoNumbers.join(', ')}?`;
    },
    disabled: (documents: STODocument[]) => {
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < documents.length; i++) {
        if (documents[i].status !== STODocumentStatusEnum.SHIP_UPDATE_FAILED)
          return true;
      }
      return false;
    },
    onConfirm: (
      dispatch: ThunkDispatch<unknown, unknown, UnknownAction>,
      stoNumbers: string[],
      location?: number,
    ): void => {
      dispatch(retryUpdateFailedSTODocuments({ stoNumbers, location }));
    },
  },
];
